import type { ModuleDefinition } from '../../../app/moduleRegistry';
import CredentialListPage from './pages/CredentialListPage';

/** Provider Ayarları (Credential) yönetimi — Master GSA only. Controller re-verified
 *  2026-08-10 against localhost:1538 (GetCredentials returned real rows); Edit-only.
 *  Confirm on the production host — see api/types/system.ts + docs/backend-requirements.md V-2. */
export const credentialModule: ModuleDefinition = {
  routes: [{ path: 'system/credential', element: <CredentialListPage /> }],
  menuItems: [
    {
      label: 'Sistem: Provider Ayarları',
      path: 'system/credential',
      isVisible: (user) => !!user?.isMasterGsa,
    },
  ],
};
